<template>
    <div>
        <div class="row">
            <div class="form-group col-md-12">
                <label>Denominazione</label>
                <input type="text" class="form-control form-control-sm" placeholder="Denominazione" v-model="persona.DENOMINAZIONE">
            </div>       
        </div>
        <div class="row">
            <div class="form-group col-md-3">
                <label>Codice fiscale</label>
                <input type="text" class="form-control form-control-sm" placeholder="Codice fiscale" v-model="persona.CODICE_FISCALE">
            </div>   
            <div class="form-group col-md-3">
                <label>Partita IVA</label>
                <input type="text" class="form-control form-control-sm" placeholder="Partita IVA" v-model="persona.PARTITA_IVA">
            </div>  
            <div class="form-group col-md-3">
                <label>Codice SDI (es. 000000)</label>
                <input type="text" class="form-control form-control-sm" placeholder="Codice destinatario" v-model="persona.CODICE_DESTINATARIO">
            </div>  
            <div class="form-group col-md-3">
                <label>PEC</label>
                <input type="text" class="form-control form-control-sm" placeholder="PEC" v-model="persona.PEC">
            </div>  
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label>Email</label>
                <input type="text" class="form-control form-control-sm" placeholder="Email" v-model="persona.EMAIL">
            </div>
            <div class="form-group col-md-6">
                <label>Telefono</label>
                <input type="text" class="form-control form-control-sm" placeholder="Telefono" v-model="persona.TELEFONO">
            </div> 
        </div>

        <div class="row">
            <div class="form-group col-md-6">
                <label>Indirizzo</label>
                <input type="text" class="form-control form-control-sm" placeholder="Indirizzo" v-model="persona.INDIRIZZO">
            </div>  
            <div class="form-group col-md-4">
                <label>Comune</label>
<!--                 <Select2 @onSelectItem="setCap($event)" v-model="persona.FK_ID_COMUNE" :w="250" :api="'core/basic/search/select2?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'"></Select2>
 -->                 <Select2 @onSelectItem="setCap($event)" v-model="persona.FK_ID_COMUNE" :w="250" :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'"></Select2>

            </div>
            <div class="form-group col-md-2">
                <label>Cap</label>
                <input type="text" class="form-control form-control-sm" placeholder="Cap" v-model="persona.CAP">
            </div> 
        </div>
    </div>
</template>

<script>
        
import { computed } from 'vue'
import Select2 from '@/components/utils/Select2.vue'

export default {
    components:{
        Select2,
    },
    props: {
      modelValue: {
          type: Object,
          default: () => ({}),
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const persona = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        return { persona };
    },
    data:function(){
        return{
            
        }
    },
    methods: {
        setCap(item){
            if (this.persona.CAP == ""){
                this.persona.CAP = item.CAP;                
            }
        }
    },
    computed: {
    
    },
}
</script>